
// import React from 'react';
// import { AppBar, Toolbar, Typography, Box, Menu, MenuItem, Button } from '@mui/material';
// import { ExpandMore } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import logo from '../Assests/logo.png';

// const NavBar = () => {
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [openMenu, setOpenMenu] = React.useState(null);
//   const navigate = useNavigate();

//   const handleClick = (event, menuName) => {
//     setAnchorEl(event.currentTarget);
//     setOpenMenu(menuName);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//     setOpenMenu(null);
//   };

//   const handleNavigate = (path) => {
//     handleClose(); // close the menu first
//     navigate(path); // then navigate
//   }; // ✅ FIX: added missing curly brace here

//   return (
//     <AppBar position="fixed" elevation={0} sx={{ backgroundColor: '#FFFFFF' }}>
//       <Toolbar sx={{ justifyContent: 'space-between', px: 3 }}>
//         {/* Logo */}
//         <Box display="flex" alignItems="center" gap={1} onClick={() => navigate('/')} sx={{ cursor: 'pointer' }}>
//           <img src={logo} alt="CA Logo" style={{ height: 50 }} />
//         </Box>

//         {/* Menu Items */}
//         <Box component="ul" sx={{ listStyle: 'none', display: 'flex', gap: 3, alignItems: 'center', m: 0, p: 0 }}>
//           {/* About Us */}
//           <li>
//             <Button
//               onClick={() => navigate('/aboutus')}
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//             >
//               About Us
//             </Button>
//           </li>

//           {/* Our Team */}
//           <li>
//             <Button
//               onClick={() => navigate('/ourteam')}
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//             >
//               Our Team
//             </Button>
//           </li>

//           {/* Services Menu */}
//           <li>
//             <Button
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               endIcon={<ExpandMore />}
//               onClick={(e) => handleClick(e, 'Services')}
//             >
//               Services
//             </Button>
//             {openMenu === 'Services' && (
//               <Menu
//                 anchorReference="none"
//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//                 PaperProps={{
//                   sx: {
//                     width: "1000px",
//                     height: "400px",
//                     position: "absolute",
//                     top: "10%",
//                     left: "10%",
//                     transform: "translate(-50%, -50%)",
//                     borderRadius: "2px",
//                     padding: "10px",
//                     overflowX: "hidden",
//                     overflowY: "auto",
//                   },
//                 }}
//               >
//                 <Box sx={{ display: "flex", flexDirection: "row", p: 2, fontSize: "12px", width: "100%", height: "100%" }}>
//                   {/* STARTUP REGISTRATION */}
//                   <Box sx={{ width: "25%", p: 1 }}>
//                     <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: "bold" }}>
//                       STARTUP REGISTRATION
//                     </Typography>
//                     <Box sx={{ width: "50%", mb: 1 }}><hr style={{ border: "1px solid #22c55e" }} /></Box>
                    
//                     <MenuItem component="a" href="/partnership" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Partnership</MenuItem>
//                     <MenuItem component="a" href="/OnePersonCompany" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>One Person Company</MenuItem>
//                     <MenuItem component="a" href="/limitedLiabilityPartnership" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Limited Liability Partnership</MenuItem>
//                     <MenuItem component="a" href="/privatelimitedcompany" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Private Limited Company</MenuItem>
//                     <MenuItem component="a" href="/trustregistration" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Trust Registration</MenuItem>
//                     <MenuItem component="a" href="/societyregistration" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Society Registration</MenuItem>
//                   </Box>

//                   {/* GST */}
//                   <Box sx={{ width: "25%", p: 1 }}>
//                     <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: "bold" }}>
//                       GOODS & SERVICE TAX
//                     </Typography>
//                     <Box sx={{ width: "50%", mb: 1 }}><hr style={{ border: "1px solid #22c55e" }} /></Box>

//                     <MenuItem component="a" href="/gstadvisoryandcompliance" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>GST advisory and compliance service</MenuItem>
//                     <MenuItem component="a" href="/gstlitigationservices" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>GST litigation services </MenuItem>
//                     <MenuItem component="a" href="/gstregistration" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>GST registration </MenuItem>
//                     <MenuItem component="a" href="/gstreturns" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>GST returns</MenuItem>
//                     <MenuItem component="a" href="/gstannualreturn" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> GST annual return  </MenuItem>
//                     <MenuItem component="a" href="/gstewaybill" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> GST eway bill </MenuItem>




                    

//                   </Box>

//                   {/* ROC COMPLIANCES */}
//                   <Box sx={{ width: "25%", p: 1 }}>
//                     <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: "bold" }}>
//                       ROC COMPLIANCES
//                     </Typography>
//                     <Box sx={{ width: "50%", mb: 1 }}><hr style={{ border: "1px solid #22c55e" }} /></Box>

//                     <MenuItem component="a" href="/annualcomplianceprivatelimited" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> Annual Compliance for Private <br/> Limited Company</MenuItem>
//                     <MenuItem component="a" href="/annualcompliancellp" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>  Annual Compliance of LLP    </MenuItem>
//                     <MenuItem component="a" href="/proprietorshipregistration" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> Section 8 Company Compliance </MenuItem>
//                   </Box>

//                   {/* AUDIT & ASSURANCE */}
//                   <Box sx={{ width: "25%", p: 1 }}>
//                     <Typography variant="h6" sx={{ fontSize: "14px", fontWeight: "bold" }}>
//                       AUDIT & ASSURANCE
//                     </Typography>
//                     <Box sx={{ width: "50%", mb: 1 }}><hr style={{ border: "1px solid #22c55e" }} /></Box>

//                      <MenuItem component="a" href="/taxauditoverview" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>  Tax Audit   </MenuItem>
//                     <MenuItem component="a" href="/certificationservices" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> Certification Services  </MenuItem>


                    
//                   </Box>
//                 </Box>
//               </Menu>
//             )}
//           </li>

//           {/* Regulatory */}
//           <li>
//             <Button
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               endIcon={<ExpandMore />}
//               onClick={(e) => handleClick(e, 'Regulatory')}
//             >
//               Regulatory
//             </Button>
//             {openMenu === 'Regulatory' && (
//               <Menu anchorEl={anchorEl} open onClose={handleClose}>
//                 <MenuItem onClick={handleClose}>Regulatory Info</MenuItem>
//               </Menu>
//             )}
//           </li>

//           {/* Licenses */}
//           <li>
//             <Button
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               endIcon={<ExpandMore />}
//               onClick={(e) => handleClick(e, 'Licenses')}
//             >
//               Licenses
//             </Button>
//             {openMenu === 'Licenses' && (
            
//                <Menu
//                 anchorReference="none"
//                 open={Boolean(anchorEl)}
//                 onClose={handleClose}
//                 PaperProps={{
//                   sx: {
//                     width: "1000px",
//                     height: "400px",
//                     position: "absolute",
//                     top: "10%",
//                     left: "10%",
//                     transform: "translate(-50%, -50%)",
//                     borderRadius: "2px",
//                     padding: "10px",
//                     overflowX: "hidden",
//                     overflowY: "auto",
//                   },
//                 }}
//               >
//                 <Box sx={{ display: "flex", flexDirection: "row", p: 2, fontSize: "12px", width: "100%", height: "100%" }}>
//                   {/* STARTUP REGISTRATION */}
//                   <Box sx={{ width: "25%", p: 1 }}>
                    
                    
//                     <MenuItem component="a" href="/shopandestablishmentactIndia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Shops & Establishment Registration</MenuItem>
//                     <MenuItem component="a" href="/udyogaadharregistration" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Udyam Registration</MenuItem>
//                     <MenuItem component="a" href="/fssaigegistrationlicense" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Fssai Registration / License</MenuItem>
//                     <MenuItem component="a" href="/trademarkregistrationindia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Trademark Registration</MenuItem>
//                     <MenuItem component="a" href="/importerexportercodeindia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Import Export Code</MenuItem>
//                     <MenuItem component="a" href="/isocertificationindia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Iso Certification</MenuItem>
//                      <MenuItem component="a" href="/reraregistrationindia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Rera Registration</MenuItem>
//                   </Box>

//                   {/* GST */}
//                   <Box sx={{ width: "25%", p: 1 }}>
                    
                    

//                     <MenuItem component="a" href="/tradelicenseindia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Trade License</MenuItem>
//                     <MenuItem component="a" href="/professionaltaxindia" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>Professional Tax</MenuItem>





                    

//                   </Box>

//                   {/* ROC COMPLIANCES */}
//                   <Box sx={{ width: "25%", p: 1 }}>
                    

//                     <MenuItem component="a" href="/annualcomplianceprivatelimited" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> Annual Compliance for Private <br/> Limited Company</MenuItem>
//                     <MenuItem component="a" href="/annualcompliancellp" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>  Annual Compliance of LLP    </MenuItem>
//                     <MenuItem component="a" href="/proprietorshipregistration" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> Section 8 Company Compliance </MenuItem>
//                   </Box>

//                   {/* AUDIT & ASSURANCE */}
//                   <Box sx={{ width: "25%", p: 1 }}>
                   

//                      <MenuItem component="a" href="/taxauditoverview" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}>  Tax Audit   </MenuItem>
//                     <MenuItem component="a" href="/certificationservices" sx={{ fontSize: "12px", textDecoration: "none", color: "inherit" }}> Certification Services  </MenuItem>


                    
//                   </Box>
//                 </Box>
//               </Menu>
//             )}
//           </li>

//           {/* Utilities */}
//           <li>
//             <Button
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               endIcon={<ExpandMore />}
//               onClick={(e) => handleClick(e, 'Utilities')}
//             >
//               Utilities
//             </Button>
//             {openMenu === 'Utilities' && (
//               <Menu anchorEl={anchorEl} open onClose={handleClose}>
//                 <MenuItem onClick={handleClose}>Tool 1</MenuItem>
//               </Menu>
//             )}
//           </li>

//           {/* Contact */}
//           <li>
//             <Button
//               onClick={() => navigate('/contact')}
//               sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//             >
//               Contact Us
//             </Button>
//           </li>
//         </Box>
//       </Toolbar>
//     </AppBar>
//   );
// };

// export default NavBar;





















// import React from 'react';
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Box,
//   Menu,
//   MenuItem,
//   Button,
//   IconButton,
//   Drawer,
//   List,
//   ListItem,
//   ListItemText,
//   useMediaQuery,
//   useTheme,
// } from '@mui/material';
// import { ExpandMore, Menu as MenuIcon } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import logo from '../Assests/logo.png';

// const NavBar = () => {
//   const [anchorEl, setAnchorEl] = React.useState(null);
//   const [openMenu, setOpenMenu] = React.useState(null);
//   const [mobileOpen, setMobileOpen] = React.useState(false);
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Breakpoint for mobile view

//   const handleClick = (event, menuName) => {
//     setAnchorEl(event.currentTarget);
//     setOpenMenu(menuName);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//     setOpenMenu(null);
//   };

//   const handleNavigate = (path) => {
//     handleClose();
//     setMobileOpen(false); // Close drawer on mobile
//     navigate(path);
//   };

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   // Menu items for Services
//   const servicesMenuItems = [
//     { label: 'Partnership', path: '/partnership' },
//     { label: 'One Person Company', path: '/OnePersonCompany' },
//     { label: 'Limited Liability Partnership', path: '/limitedLiabilityPartnership' },
//     { label: 'Private Limited Company', path: '/privatelimitedcompany' },
//     { label: 'Trust Registration', path: '/trustregistration' },
//     { label: 'Society Registration', path: '/societyregistration' },
//   ];

//   const gstMenuItems = [
//     { label: 'GST Advisory and Compliance Service', path: '/gstadvisoryandcompliance' },
//     { label: 'GST Litigation Services', path: '/gstlitigationservices' },
//     { label: 'GST Registration', path: '/gstregistration' },
//     { label: 'GST Returns', path: '/gstreturns' },
//     { label: 'GST Annual Return', path: '/gstannualreturn' },
//     { label: 'GST Eway Bill', path: '/gstewaybill' },
//   ];

//   const rocMenuItems = [
//     { label: 'Annual Compliance for Private Limited Company', path: '/annualcomplianceprivatelimited' },
//     { label: 'Annual Compliance of LLP', path: '/annualcompliancellp' },
//     { label: 'Section 8 Company Compliance', path: '/proprietorshipregistration' },
//   ];

//   const auditMenuItems = [
//     { label: 'Tax Audit', path: '/taxauditoverview' },
//     { label: 'Certification Services', path: '/certificationservices' },
//   ];

//   const licensesMenuItems = [
//     { label: 'Shops & Establishment Registration', path: '/shopandestablishmentactIndia' },
//     { label: 'Udyam Registration', path: '/udyogaadharregistration' },
//     { label: 'FSSAI Registration / License', path: '/fssaigegistrationlicense' },
//     { label: 'Trademark Registration', path: '/trademarkregistrationindia' },
//     { label: 'Import Export Code', path: '/importerexportercodeindia' },
//     { label: 'ISO Certification', path: '/isocertificationindia' },
//     { label: 'RERA Registration', path: '/reraregistrationindia' },
//     { label: 'Trade License', path: '/tradelicenseindia' },
//     { label: 'Professional Tax', path: '/professionaltaxindia' },
//   ];

//   // Drawer content for mobile view
//   const drawerContent = (
//     <Box sx={{ width: 300, p: 2, bgcolor: '#FFFFFF' }}>
//       <List>
//         <ListItem button onClick={() => handleNavigate('/aboutus')}>
//           <ListItemText primary="About Us" sx={{ color: '#000' }} />
//         </ListItem>
//         <ListItem button onClick={() => handleNavigate('/ourteam')}>
//           <ListItemText primary="Our Team" sx={{ color: '#000' }} />
//         </ListItem>
//         <ListItem button onClick={() => setOpenMenu(openMenu === 'Services' ? null : 'Services')}>
//           <ListItemText primary="Services" sx={{ color: '#000' }} />
//           <ExpandMore sx={{ color: '#000' }} />
//         </ListItem>
//         {openMenu === 'Services' && (
//           <Box sx={{ pl: 2, py: 1 }}>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//               <Button
//                 onClick={() => handleNavigate('/partnership')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Partnership
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/OnePersonCompany')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 One Person Company
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/limitedLiabilityPartnership')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Limited Liability Partnership
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/privatelimitedcompany')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Private Limited Company
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/trustregistration')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Trust Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/societyregistration')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Society Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/gstadvisoryandcompliance')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 GST Advisory and Compliance Service
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/gstlitigationservices')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 GST Litigation Services
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/gstregistration')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 GST Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/gstreturns')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 GST Returns
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/gstannualreturn')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 GST Annual Return
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/gstewaybill')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 GST Eway Bill
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/annualcomplianceprivatelimited')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Annual Compliance for Private Limited Company
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/annualcompliancellp')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Annual Compliance of LLP
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/proprietorshipregistration')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Section 8 Company Compliance
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/taxauditoverview')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Tax Audit
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/certificationservices')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Certification Services
//               </Button>
//             </Box>
//           </Box>
//         )}
//         <ListItem button onClick={() => setOpenMenu(openMenu === 'Regulatory' ? null : 'Regulatory')}>
//           <ListItemText primary="Regulatory" sx={{ color: '#000' }} />
//           <ExpandMore sx={{ color: '#000' }} />
//         </ListItem>
//         {openMenu === 'Regulatory' && (
//           <Box sx={{ pl: 2, py: 1 }}>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//               <Button
//                 onClick={() => handleNavigate('/regulatory')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Regulatory Info
//               </Button>
//             </Box>
//           </Box>
//         )}
//         <ListItem button onClick={() => setOpenMenu(openMenu === 'Licenses' ? null : 'Licenses')}>
//           <ListItemText primary="Licenses" sx={{ color: '#000' }} />
//           <ExpandMore sx={{ color: '#000' }} />
//         </ListItem>
//         {openMenu === 'Licenses' && (
//           <Box sx={{ pl: 2, py: 1 }}>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//               <Button
//                 onClick={() => handleNavigate('/shopandestablishmentactIndia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Shops & Establishment Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/udyogaadharregistration')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Udyam Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/fssaigegistrationlicense')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 FSSAI Registration / License
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/trademarkregistrationindia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Trademark Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/importerexportercodeindia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Import Export Code
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/isocertificationindia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 ISO Certification
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/reraregistrationindia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 RERA Registration
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/tradelicenseindia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Trade License
//               </Button>
//               <Button
//                 onClick={() => handleNavigate('/professionaltaxindia')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Professional Tax
//               </Button>
//             </Box>
//           </Box>
//         )}
//         <ListItem button onClick={() => setOpenMenu(openMenu === 'Utilities' ? null : 'Utilities')}>
//           <ListItemText primary="Utilities" sx={{ color: '#000' }} />
//           <ExpandMore sx={{ color: '#000' }} />
//         </ListItem>
//         {openMenu === 'Utilities' && (
//           <Box sx={{ pl: 2, py: 1 }}>
//             <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//               <Button
//                 onClick={() => handleNavigate('/tool1')}
//                 sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px' }}
//               >
//                 Tool 1
//               </Button>
//             </Box>
//           </Box>
//         )}
//         <ListItem button onClick={() => handleNavigate('/contact')}>
//           <ListItemText primary="Contact Us" sx={{ color: '#000' }} />
//         </ListItem>
//       </List>
//     </Box>
//   );

//   return (
//     <AppBar position="fixed" elevation={0} sx={{ backgroundColor: '#FFFFFF' }}>
//       <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 1, md: 3 } }}>
//         {/* Logo */}
//         {/* <Box
//           display="flex"
//           alignItems="center"
//           gap={1}
//           onClick={() => navigate('/')}
//           sx={{ cursor: 'pointer' }}
//         >
//           <img src={logo} alt="CA Logo" style={{ height: { xs: 40, md: 50 } }} />
//         </Box> */}

//         <Box
//   display="flex"
//   alignItems="center"
//   gap={1}
//   onClick={() => navigate('/')}
//   sx={{ cursor: 'pointer' }}
// >
//   <Box
//     component="img"
//     src={logo}
//     alt="CA Logo"
//     sx={{
//       height: { xs: 50, md: 60 }, // reduced height
//       width: { xs: 350, md: 360 },  // reduced width
//     }}
//   />
// </Box>


//         {/* Desktop Menu */}
//         {!isMobile && (
//           <Box
//             component="ul"
//             sx={{ listStyle: 'none', display: 'flex', gap: 3, alignItems: 'center', m: 0, p: 0 }}
//           >
//             <li>
//               <Button
//                 onClick={() => navigate('/aboutus')}
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               >
//                 About Us
//               </Button>
//             </li>
//             <li>
//               <Button
//                 onClick={() => navigate('/ourteam')}
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               >
//                 Our Team
//               </Button>
//             </li>
//             <li>
//               <Button
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//                 endIcon={<ExpandMore />}
//                 onClick={(e) => handleClick(e, 'Services')}
//               >
//                 Services
//               </Button>
//               {openMenu === 'Services' && (
//                 <Menu
//                   anchorReference="none"
//                   open={Boolean(anchorEl)}
//                   onClose={handleClose}
//                   PaperProps={{
//                     sx: {
//                       width: '1000px',
//                       height: '400px',
//                       position: 'absolute',
//                       top: '10%',
//                       left: '10%',
//                       transform: 'translate(-50%, -50%)',
//                       borderRadius: '2px',
//                       padding: '10px',
//                       overflowX: 'hidden',
//                       overflowY: 'auto',
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'row',
//                       p: 2,
//                       fontSize: '12px',
//                       width: '100%',
//                       height: '100%',
//                     }}
//                   >
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
//                         STARTUP REGISTRATION
//                       </Typography>
//                       <Box sx={{ width: '50%', mb: 1 }}>
//                         <hr style={{ border: '1px solid #22c55e' }} />
//                       </Box>
//                       {servicesMenuItems.map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
//                         GOODS & SERVICE TAX
//                       </Typography>
//                       <Box sx={{ width: '50%', mb: 1 }}>
//                         <hr style={{ border: '1px solid #22c55e' }} />
//                       </Box>
//                       {gstMenuItems.map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
//                         ROC COMPLIANCES
//                       </Typography>
//                       <Box sx={{ width: '50%', mb: 1 }}>
//                         <hr style={{ border: '1px solid #22c55e' }} />
//                       </Box>
//                       {rocMenuItems.map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
//                         AUDIT & ASSURANCE
//                       </Typography>
//                       <Box sx={{ width: '50%', mb: 1 }}>
//                         <hr style={{ border: '1px solid #22c55e' }} />
//                       </Box>
//                       {auditMenuItems.map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                   </Box>
//                 </Menu>
//               )}
//             </li>
//             <li>
//               <Button
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//                 endIcon={<ExpandMore />}
//                 onClick={(e) => handleClick(e, 'Regulatory')}
//               >
//                 Regulatory
//               </Button>
//               {openMenu === 'Regulatory' && (
//                 <Menu anchorEl={anchorEl} open onClose={handleClose}>
//                   <MenuItem onClick={() => handleNavigate('/regulatory')}>Regulatory Info</MenuItem>
//                 </Menu>
//               )}
//             </li>
//             <li>
//               <Button
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//                 endIcon={<ExpandMore />}
//                 onClick={(e) => handleClick(e, 'Licenses')}
//               >
//                 Licenses
//               </Button>
//               {openMenu === 'Licenses' && (
//                 <Menu
//                   anchorReference="none"
//                   open={Boolean(anchorEl)}
//                   onClose={handleClose}
//                   PaperProps={{
//                     sx: {
//                       width: '1000px',
//                       height: '400px',
//                       position: 'absolute',
//                       top: '10%',
//                       left: '10%',
//                       transform: 'translate(-50%, -50%)',
//                       borderRadius: '2px',
//                       padding: '10px',
//                       overflowX: 'hidden',
//                       overflowY: 'auto',
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       flexDirection: 'row',
//                       p: 2,
//                       fontSize: '12px',
//                       width: '100%',
//                       height: '100%',
//                     }}
//                   >
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       {licensesMenuItems.slice(0, 7).map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       {licensesMenuItems.slice(7).map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       {rocMenuItems.map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                     <Box sx={{ width: '25%', p: 1 }}>
//                       {auditMenuItems.map((item) => (
//                         <MenuItem
//                           key={item.path}
//                           component="a"
//                           href={item.path}
//                           sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
//                         >
//                           {item.label}
//                         </MenuItem>
//                       ))}
//                     </Box>
//                   </Box>
//                 </Menu>
//               )}
//             </li>
//             <li>
//               <Button
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//                 endIcon={<ExpandMore />}
//                 onClick={(e) => handleClick(e, 'Utilities')}
//               >
//                 Utilities
//               </Button>
//               {openMenu === 'Utilities' && (
//                 <Menu anchorEl={anchorEl} open onClose={handleClose}>
//                   <MenuItem onClick={() => handleNavigate('/tool1')}>Tool 1</MenuItem>
//                 </Menu>
//               )}
//             </li>
//             <li>
//               <Button
//                 onClick={() => navigate('/contact')}
//                 sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
//               >
//                 Contact Us
//               </Button>
//             </li>
//           </Box>
//         )}

//         {/* Mobile Hamburger Menu */}
//         {isMobile && (
//           <IconButton
//             color="inherit"
//             aria-label="open drawer"
//             edge="end"
//             onClick={handleDrawerToggle}
//             sx={{ color: '#000' }}
//           >
//             <MenuIcon />
//           </IconButton>
//         )}
//       </Toolbar>

//       {/* Mobile Drawer */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={handleDrawerToggle}
//         ModalProps={{
//           keepMounted: true, // Better performance on mobile
//         }}
//       >
//         {drawerContent}
//       </Drawer>
//     </AppBar>
//   );
// };

// export default NavBar;


























import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Menu,
  MenuItem,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ExpandMore, Menu as MenuIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import logo from '../Assests/logo.jpg';
import logo2 from '../Assests/logo2.png';
import Logo from '../Assests/Logo.png';
import logo3 from '../Assests/logo3.png';

const NavBar = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMenu, setOpenMenu] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Breakpoint for mobile view

  const handleClick = (event, menuName) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(menuName);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpenMenu(null);
  };

  const handleNavigate = (path) => {
    handleClose();
    setMobileOpen(false); // Close drawer on mobile
    navigate(path);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Menu items for Services
  const servicesMenuItems = [
    { label: 'Partnership', path: '/partnership' },
    { label: 'One Person Company', path: '/OnePersonCompany' },
    { label: 'Limited Liability Partnership', path: '/limitedLiabilityPartnership' },
    { label: 'Private Limited Company', path: '/privatelimitedcompany' },
    { label: 'Trust Registration', path: '/trustregistration' },
    { label: 'Society Registration', path: '/societyregistration' },
    { label: 'GST Advisory and Compliance Service', path: '/gstadvisoryandcompliance' },
    { label: 'GST Litigation Services', path: '/gstlitigationservices' },
    { label: 'GST Registration', path: '/gstregistration' },
    { label: 'GST Returns', path: '/gstreturns' },
    { label: 'GST Annual Return', path: '/gstannualreturn' },
    { label: 'GST Eway Bill', path: '/gstewaybill' },
    { label: 'Annual Compliance for Private Limited Company', path: '/annualcomplianceprivatelimited' },
    { label: 'Annual Compliance of LLP', path: '/annualcompliancellp' },
    { label: 'Section 8 Company Compliance', path: '/proprietorshipregistration' },
    { label: 'Tax Audit', path: '/taxauditoverview' },
    { label: 'Certification Services', path: '/certificationservices' },
  ];

  const licensesMenuItems = [
    { label: 'Shops & Establishment Registration', path: '/shopandestablishmentactIndia' },
    { label: 'Udyam Registration', path: '/udyogaadharregistration' },
    { label: 'FSSAI Registration / License', path: '/fssaigegistrationlicense' },
    { label: 'Trademark Registration', path: '/trademarkregistrationindia' },
    { label: 'Import Export Code', path: '/importerexportercodeindia' },
    { label: 'ISO Certification', path: '/isocertificationindia' },
    { label: 'RERA Registration', path: '/reraregistrationindia' },
    { label: 'Trade License', path: '/tradelicenseindia' },
    { label: 'Professional Tax', path: '/professionaltaxindia' },
  ];

  const rocMenuItems = [
    { label: 'Annual Compliance for Private Limited Company', path: '/annualcomplianceprivatelimited' },
    { label: 'Annual Compliance of LLP', path: '/annualcompliancellp' },
    { label: 'Section 8 Company Compliance', path: '/proprietorshipregistration' },
  ];

  const auditMenuItems = [
    { label: 'Tax Audit', path: '/taxauditoverview' },
    { label: 'Certification Services', path: '/certificationservices' },
  ];

  // Drawer content for mobile view
  const drawerContent = (
    <Box sx={{ width: 300, p: 2, bgcolor: '#FFFFFF' }}>
      <List>
        <ListItem button onClick={() => handleNavigate('/aboutus')}>
          <ListItemText primary="About Us" sx={{ color: '#000' }} />
        </ListItem>
        <ListItem button onClick={() => handleNavigate('/ourteam')}>
          <ListItemText primary="Our Team" sx={{ color: '#000' }} />
        </ListItem>
        <ListItem button onClick={() => setOpenMenu(openMenu === 'Services' ? null : 'Services')}>
          <ListItemText primary="Services" sx={{ color: '#000' }} />
          <ExpandMore sx={{ color: '#000' }} />
        </ListItem>
        {openMenu === 'Services' && (
          <Box sx={{ pl: 2, py: 1 }}>
            {servicesMenuItems.map((item) => (
              <Button
                key={item.path}
                onClick={() => handleNavigate(item.path)}
                sx={{
                  display: 'block',
                  fontSize: '12px',
                  color: '#000',
                  textTransform: 'none',
                  '&:hover': { color: '#5DA840' },
                  minWidth: 'auto',
                  padding: '4px 8px',
                  width: '100%',
                  textAlign: 'left',
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
        <ListItem button onClick={() => setOpenMenu(openMenu === 'Regulatory' ? null : 'Regulatory')}>
          <ListItemText primary="Regulatory" sx={{ color: '#000' }} />
          <ExpandMore sx={{ color: '#000' }} />
        </ListItem>
        {openMenu === 'Regulatory' && (
          <Box sx={{ pl: 2, py: 1 }}>
            <Button
              onClick={() => handleNavigate('/regulatory')}
              sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px', display: 'block', width: '100%', textAlign: 'left' }}
            >
              Regulatory Info
            </Button>
          </Box>
        )}
        <ListItem button onClick={() => setOpenMenu(openMenu === 'Licenses' ? null : 'Licenses')}>
          <ListItemText primary="Licenses" sx={{ color: '#000' }} />
          <ExpandMore sx={{ color: '#000' }} />
        </ListItem>
        {openMenu === 'Licenses' && (
          <Box sx={{ pl: 2, py: 1 }}>
            {licensesMenuItems.map((item) => (
              <Button
                key={item.path}
                onClick={() => handleNavigate(item.path)}
                sx={{
                  display: 'block',
                  fontSize: '12px',
                  color: '#000',
                  textTransform: 'none',
                  '&:hover': { color: '#5DA840' },
                  minWidth: 'auto',
                  padding: '4px 8px',
                  width: '100%',
                  textAlign: 'left',
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>
        )}
        {/* <ListItem button onClick={() => setOpenMenu(openMenu === 'Utilities' ? null : 'Utilities')}>
          <ListItemText primary="Utilities" sx={{ color: '#000' }} />
          <ExpandMore sx={{ color: '#000' }} />
        </ListItem> */}
        {/* {openMenu === 'Utilities' && (
          <Box sx={{ pl: 2, py: 1 }}>
            <Button
              onClick={() => handleNavigate('/tool1')}
              sx={{ fontSize: '12px', color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' }, minWidth: 'auto', padding: '4px 8px', display: 'block', width: '100%', textAlign: 'left' }}
            >
              Tool 1
            </Button>
          </Box>
        )} */}
        <ListItem button onClick={() => handleNavigate('/contact')}>
          <ListItemText primary="Contact Us" sx={{ color: '#000' }} />
        </ListItem>
      </List>
    </Box>
  );

  return (
    <AppBar position="fixed" elevation={0} sx={{ backgroundColor: '#FFFFFF' }}>
      {/* FFFFFF */}
      <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 1, md: 3 } }}>
        {/* Logo */}
        {/* <Box
          display="flex"
          alignItems="center"
          gap={1}
          onClick={() => navigate('/')}
          sx={{ cursor: 'pointer',marginLeft:'20px' }}
        >
          <Box
            component="img"
            src={Logo}
            alt="CA Logo"
            sx={{
              height: { xs: 30, md: 50 }, // reduced height
              width: { xs: 70, md: 80 },  // reduced width
            
            }}
          />
        </Box>


        <div
  style={{
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
    fontSize: "16px",
    color: "#0C2C4C", // dark blue similar to your image
    // lineHeight: "1.4",
    letterSpacing: "1px",
    textTransform: "uppercase",
     marginRight:'300px',

  }}
>
  PDN & ASSOCIATES
  <br />
  CHARTERED ACCOUNTANTS
</div> */}


<Box
  display="flex"
  alignItems="center"
  gap={1}
  onClick={() => navigate('/')}
  sx={{ cursor: "pointer", marginLeft: { xs: "10px", md: "20px" } }}
>
  {/* Logo */}
  <Box
    component="img"
    src={Logo}
    alt="CA Logo"
    sx={{
      height: { xs: 30, md: 50 },
      width: { xs: 70, md: 80 },
    }}
  />

  {/* Firm Name */}
  <Box
    sx={{
      fontFamily: "Arial, sans-serif",
      fontWeight: "bold",
      fontSize: { xs: "12px", sm: "14px", md: "16px" }, // responsive font
      color: "#0C2C4C",
      letterSpacing: "1px",
      textTransform: "uppercase",
      marginRight: { xs: "20px", md: "300px" }, // responsive spacing
      lineHeight: 1.3,
    }}
  >
    PDN & ASSOCIATES
    <br />
    CHARTERED ACCOUNTANTS
  </Box>
</Box>

        

        {/* Desktop Menu */}
        {!isMobile && (
          <Box
            component="ul"
            sx={{ listStyle: 'none', display: 'flex', gap: 3, alignItems: 'center', m: 0, p: 0 }}
          >
            <li>
              <Button
                onClick={() => navigate('/aboutus')}
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
              >
                About Us
              </Button>
            </li>
            <li>
              <Button
                onClick={() => navigate('/ourteam')}
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
              >
                Our Team
              </Button>
            </li>
            <li>
              <Button
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
                endIcon={<ExpandMore />}
                onClick={(e) => handleClick(e, 'Services')}
              >
                Services
              </Button>
              {openMenu === 'Services' && (
                <Menu
                  anchorReference="none"
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    sx: {
                      width: '1000px',
                      height: '290px',
                      position: 'absolute',
                      top: '10%',
                      left: '10%',
                      transform: 'translate(-50%, -50%)',
                      borderRadius: '2px',
                      padding: '10px',
                      overflowX: 'hidden',
                      overflowY: 'auto',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      p: 2,
                      fontSize: '12px',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Box sx={{ width: '25%', p: 1 }}>
                      <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                        STARTUP REGISTRATION
                      </Typography>
                      <Box sx={{ width: '50%', mb: 1 }}>
                        <hr style={{ border: '1px solid #22c55e' }} />
                      </Box>
                      {servicesMenuItems.slice(0, 6).map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                    <Box sx={{ width: '25%', p: 1 }}>
                      <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                        GOODS & SERVICE TAX
                      </Typography>
                      <Box sx={{ width: '50%', mb: 1 }}>
                        <hr style={{ border: '1px solid #22c55e' }} />
                      </Box>
                      {servicesMenuItems.slice(6, 12).map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                    <Box sx={{ width: '25%', p: 1 }}>
                      <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                        ROC COMPLIANCES
                      </Typography>
                      <Box sx={{ width: '50%', mb: 1 }}>
                        <hr style={{ border: '1px solid #22c55e' }} />
                      </Box>
                      {servicesMenuItems.slice(12, 15).map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                    <Box sx={{ width: '25%', p: 1 }}>
                      <Typography variant="h6" sx={{ fontSize: '14px', fontWeight: 'bold' }}>
                        AUDIT & ASSURANCE
                      </Typography>
                      <Box sx={{ width: '50%', mb: 1 }}>
                        <hr style={{ border: '1px solid #22c55e' }} />
                      </Box>
                      {servicesMenuItems.slice(15).map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                  </Box>
                </Menu>
              )}
            </li>
            {/* <li>
              <Button
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
                endIcon={<ExpandMore />}
                onClick={(e) => handleClick(e, 'Regulatory')}
              >
                Regulatory
              </Button>
              {openMenu === 'Regulatory' && (
                <Menu anchorEl={anchorEl} open onClose={handleClose}>
                  <MenuItem onClick={() => handleNavigate('/regulatory')}>Regulatory Info</MenuItem>
                </Menu>
              )}
            </li> */}
            <li>
              <Button
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
                endIcon={<ExpandMore />}
                onClick={(e) => handleClick(e, 'Licenses')}
              >
                Licenses
              </Button>
              {openMenu === 'Licenses' && (
                <Menu
                  anchorReference="none"
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  PaperProps={{
                    sx: {
                      width: '1000px',
                      height: '280px',
                      position: 'absolute',
                      top: '10%',
                      left: '10%',
                      transform: 'translate(-50%, -50%)',
                      borderRadius: '2px',
                      padding: '10px',
                      overflowX: 'hidden',
                      overflowY: 'auto',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      p: 2,
                      fontSize: '12px',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <Box sx={{ width: '25%', p: 1 }}>
                      {licensesMenuItems.slice(0, 7).map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                    <Box sx={{ width: '25%', p: 1 }}>
                      {licensesMenuItems.slice(7).map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box>
                    {/* <Box sx={{ width: '25%', p: 1 }}>
                      {rocMenuItems.map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box> */}
                    {/* <Box sx={{ width: '25%', p: 1 }}>
                      {auditMenuItems.map((item) => (
                        <MenuItem
                          key={item.path}
                          component="a"
                          href={item.path}
                          sx={{ fontSize: '12px', textDecoration: 'none', color: 'inherit' }}
                        >
                          {item.label}
                        </MenuItem>
                      ))}
                    </Box> */}
                  </Box>
                </Menu>
              )}
            </li>
            {/* <li>
              <Button
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
                endIcon={<ExpandMore />}
                onClick={(e) => handleClick(e, 'Utilities')}
              >
                Utilities
              </Button>
              {openMenu === 'Utilities' && (
                <Menu anchorEl={anchorEl} open onClose={handleClose}>
                  <MenuItem onClick={() => handleNavigate('/tool1')}>Tool 1</MenuItem>
                </Menu>
              )}
            </li> */}
            <li>
              <Button
                onClick={() => navigate('/contact')}
                sx={{ color: '#000', textTransform: 'none', '&:hover': { color: '#5DA840' } }}
              >
                Contact Us
              </Button>
            </li>
          </Box>
        )}

        {/* Mobile Hamburger Menu */}
        {isMobile && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="end"
            onClick={handleDrawerToggle}
            sx={{ color: '#000' }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true, // Better performance on mobile
        }}
      >
        {drawerContent}
      </Drawer>
    </AppBar>
  );
};

export default NavBar;